import { Reveal, SectionTag } from "./shared";
import { Compass, Layers, LineChart, ShieldCheck, KeyRound } from "lucide-react";

const PILLARS = [
  { icon: Compass, num: "01", title: "Specialist Knowledge", desc: "Deep, singular focus on Gaur Yamuna City and the Yamuna corridor - its sectors, developers, inventory cycles and infrastructure pipeline." },
  { icon: Layers, num: "02", title: "Multiple Inventories", desc: "Access to apartments, plots, villas, commercial and verified resale opportunities across the township and its surroundings." },
  { icon: LineChart, num: "03", title: "Market Intelligence", desc: "We study the infrastructure and development surrounding each property - so you understand what you are buying into, not just what you are buying." },
  { icon: ShieldCheck, num: "04", title: "Transparent Advisory", desc: "No exaggerated return promises. We work with verified information, clear status labels and honest risk framing." },
  { icon: KeyRound, num: "05", title: "End-to-End Support", desc: "From property selection to site visits, documentation guidance and transaction support - one accountable advisory desk." },
];

export function Difference() {
  return (
    <section id="difference" className="relative py-28 lg:py-40 bg-[#0A0A0A]" data-testid="difference-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionTag>The Radiance Difference</SectionTag>
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-20 items-end mb-16 lg:mb-24">
          <Reveal delay={0.05}>
            <h2 className="font-serif-lux text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#F5F5F0]">
              Property Is Everywhere.<br />
              <span className="text-gold-gradient italic">Perspective Isn&rsquo;t.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="text-sm sm:text-base text-[#A1A1AA] leading-relaxed max-w-lg">
              We don&rsquo;t simply show properties. We study locations, infrastructure, development
              patterns, inventory, pricing and long-term demand drivers to help clients identify
              the right opportunity &mdash; then we stand beside them through the transaction.
            </p>
          </Reveal>
        </div>

        <div className="border-t border-[#D4AF37]/12">
          {PILLARS.map((p, i) => (
            <Reveal key={p.num} delay={i * 0.06}>
              <div
                data-testid={`difference-pillar-${p.num}`}
                className="group grid grid-cols-[auto_1fr] lg:grid-cols-[80px_1fr_1.2fr_auto] gap-5 lg:gap-10 items-center py-8 border-b border-[#D4AF37]/12 hover:bg-[#141414]/60 transition-colors duration-500 px-2 lg:px-4"
              >
                <span className="font-serif-lux text-2xl text-[#D4AF37]/50 group-hover:text-[#D4AF37] transition-colors">{p.num}</span>
                <h3 className="font-serif-lux text-xl sm:text-2xl text-[#F5F5F0]">{p.title}</h3>
                <p className="col-span-2 lg:col-span-1 text-sm text-[#71717A] leading-relaxed max-w-xl">{p.desc}</p>
                <p.icon size={26} strokeWidth={1.2} className="hidden lg:block text-[#D4AF37]/40 group-hover:text-[#D4AF37] transition-colors" />
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
